import React, { Component } from 'react';
import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
import TestimFamily from '../../images/testimfamily.png';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const dotsSettings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
};
class WhatParentsSay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }

    render() {
        return (
            <section className="page-section bg-secondary text-white testimsec">
                <h2 className="yellowtxt">What Parents Say</h2>
                <div
                    id="myCarousel"
                    className="carousel slide"
                    data-ride="carousel"
                >
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                        {...dotsSettings}
                        className="carousel-indicators"
                    >
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        
                    </Slider>
                    <Slider
                        {...settings}
                        asNavFor={this.state.nav1}
                        ref={slider => (this.slider2 = slider)}
                        className="carousel-inner"
                    >
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “This place is amazing for kids of all abilities/needs/stages. 10/10 highly recommend.” </p>
                            <p className="overview">Hannah H</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “Great place came in from Des Moines., will be back no doubt!  also staff is great and understanding.”  </p>
                            <p className="overview">Janeth N</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “What a fun place! Both of my kids absolutely loved it! The facility is clean and so well thought out for all kids and there is lots to do for all ages."</p>
                            <p className="overview">
                            Tracy E </p>
                        </div>

                         <div className="item carousel-item">
                            <p className="testimonial">
                            “This is an amazing facility! We have been to multiple indoor parks and this is the top one we’ve been to. My kiddos (ages 2 and 4) could spend all day here."  </p>
                            <p className="overview">
                            Emma R</p>
                        </div> 
                       <div className="item carousel-item">
                            <p className="testimonial">
                            “This place is amazing! So clean and a great place for littles to play."  </p>
                            <p className="overview">
                            Molly P</p>
                        </div> 
                    </Slider>
                    <img
                        className="quoteimg"
                        src={TestimFamily}
                        alt="Testimonials family"
                    />
                </div>
            </section>
        );
    }
}

export default WhatParentsSay;
